import type { SceneContent } from '../../presentation/types';

export const process: SceneContent = {
  id: 'process',
  shortLabel: 'PROCESS',
  title: 'How Moderta Builds',
  seconds: 60,
  brand: 'moderta',
  bridgeIn: 'None of that is where Moderta starts, though.',
  atmosphere: (step) => ({ pattern: step === 0 ? 'inward' : step >= 6 ? 'ambient' : 'orbit', density: 0.2, opacity: 0.06, cameraZ: 14 }),
  script: {
    title: 'How Moderta Builds',
    onScreen: ['UNDERSTAND', 'DESIGN', 'BUILD', 'CONNECT', 'LEARN', 'EVOLVE', 'SOFTWARE IS NEVER THE FIRST STEP.', 'UNDERSTANDING IS.'],
    visual: 'Sixteen fragments drift in scattered and gather into a loose cluster. They snap into a designed grid, fill in and become solid, connect out to four external systems, receive a feedback signal that loops back into them, and finally grow new cells. The six words advance along the top as each transformation happens.',
    narration: [
      'Every Moderta product is built the same way. It starts by understanding: pulling scattered information about the problem together.',
      'Then design gives it structure.',
      'Build makes it real.',
      'Connect links it to the data, APIs and services around it.',
      'Learn brings feedback back in from real use.',
      'And evolve changes the system based on what was learned. Then the loop starts again.',
      'So software is never the first step.',
      'Understanding is.',
    ],
    presenterNotes: [
      'Fragments gather. "It starts by understanding."',
      'They snap into a grid. "Design gives it structure."',
      'Cells fill. "Build makes it real."',
      'External systems connect. "Connect."',
      'Feedback loops back in. "Learn from real use."',
      'New cells grow. "Evolve." Then pause.',
      '"Software is never the first step."',
      '"Understanding is." Let it land.',
    ],
  },
};
